document.querySelectorAll('.ingredient-match').forEach(function (root) {
  var track = root.querySelector('.ingredient-match__track');
  var prev = root.querySelector('.ingredient-match__arrow--prev');
  var next = root.querySelector('.ingredient-match__arrow--next');
  if (!track || !prev || !next) return;

  function slideWidth() {
    var slide = track.querySelector('.ingredient-match__slide');
    return slide ? slide.getBoundingClientRect().width + 16 : track.clientWidth;
  }

  function updateArrows() {
    var max = track.scrollWidth - track.clientWidth - 2;
    prev.disabled = track.scrollLeft <= 0;
    next.disabled = track.scrollLeft >= max;
  }

  prev.addEventListener('click', function () {
    track.scrollBy({ left: -slideWidth(), behavior: 'smooth' });
  });
  next.addEventListener('click', function () {
    track.scrollBy({ left: slideWidth(), behavior: 'smooth' });
  });
  track.addEventListener('scroll', updateArrows, { passive: true });
  window.addEventListener('resize', updateArrows);
  updateArrows();
});
